// @ts-nocheck
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { GetReportOrderFrequencyApiParameter } from "@store/Framework/Types/types";

const useUpdateSearchFields = () => {
    const dispatch = useBunzlDispatch();
    return (params: GetReportOrderFrequencyApiParameter) =>
        dispatch({
            type: "Store/Pages/ReportOrderFrequency/UpdateReportSearchFields",
            parameter: params,
        });
};

export default useUpdateSearchFields;
